import React from 'react';

import {labels as utilLabels} from '../../../../../../../util/utils';

import {IconoirInfoCircle} from '@ey-xd/motif-icon';
import Icon from '@ey/canvascoreservices/Icon';
import OutputText from '@ey/canvascoreservices/OutputText';

import Dropdown from '../../../../../../CoreWrappers/Dropdown';
import StyledDetails, {StyledPspPadding} from './StyledDetails';
import Utility from '../../../../../../../util/utilityfunctions';

export const prop = 'accounts';

export const config = (labels) => ({
	id: 'detailsColumn',
	label: labels.details,
	propName: prop,
	width: 'var(--px-90)',
	customCell: (item) => {
		const renderTrigger = () => <Icon src={IconoirInfoCircle} />;

		const renderAccount = ({id, label}) => {
			const props = {
				key: id,
				title: label,
				maxWidth: 'var(--px-240)',
				ellipsis: true
			};

			return <OutputText {...props}>{label}</OutputText>;
		};

		const renderPspIndex = ({id, label}) => {
			const props = {
				key: id,
				title: label,
				maxWidth: 'var(--px-240)',
				light: true,
				ellipsis: true
			};

			return <StyledPspPadding {...props}>{label}</StyledPspPadding>;
		};

		const renderEmpty = ({id, label}) => {
			const props = {
				key: id,
				maxWidth: 'var(--px-240)',
				light: true,
				className: 'empty-label'
			};

			return <OutputText {...props}>{label}</OutputText>;
		};

		const items = [];

		item.accounts.forEach((a) => {
			items.push({
				id: a.accountId,
				label: a.accountName,
				customRender: renderAccount,
				type: 'container'
			});
			a.pspIndexes.forEach((p) => {
				items.push({
					id: p.pspIndexId,
					label: p.pspIndexTitle,
					customRender: renderPspIndex,
					type: 'container'
				});
			});
		});

		const isEmpty = !(items.length > 0);

		if (isEmpty)
			items.push({
				id: 'empty',
				label: utilLabels.noAccountOrPspAssociated,
				customRender: renderEmpty,
				type: 'container'
			});

		const props = {
			placement: 'bottom-right',
			trigger: renderTrigger(),
			items,
			header: () => (
				<OutputText body1 ellipsis title={utilLabels.accountAndAsssociated}>
					{utilLabels.accountAndAsssociated}
				</OutputText>
			),
			topfix: true,
			reversed: true,
			maxItems: 5,
			itemSize: 44
		};

		return (
			<StyledDetails>
				<Dropdown {...props} />
			</StyledDetails>
		);
	}
});
